"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const axios_1 = __importStar(require("axios"));
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const api_1 = require("@/api");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const material_ui_confirm_1 = require("material-ui-confirm");
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
function default_1({ userId, formReturn, isPaymentRequest, isCompanyRegister, }) {
    const [isUploadingFile, setIsUploadingFile] = (0, react_1.useState)(false);
    const errorToastMessage = (0, react_1.useRef)('');
    const { t } = (0, react_i18next_1.useTranslation)();
    const supportExtensionRegExp = new RegExp(/(jpeg|jpg|png|heic|heif|pdf)/);
    const compressableImageType = new RegExp(/image\/(jpeg|jpg|png)/);
    const getFilteredFileObj = (file) => __awaiter(this, void 0, void 0, function* () {
        const fileType = file.type;
        let fileExtension = fileType.split('/').pop() || '';
        if (!supportExtensionRegExp.test(fileExtension)) {
            errorToastMessage.current = t('이미지, pdf 파일만 올릴 수 있어요');
        }
        else if (file.name.length > 218) {
            errorToastMessage.current = t('파일 이름을 짧게 줄여주세요');
        }
        else {
            let filtered = file;
            if (compressableImageType.test(fileType)) {
                const compressedFile = yield new Promise(resolve => {
                    (0, functions_1.compressImageFile)({
                        imageFile: file,
                        maxWidth: 1500,
                        quality: 0.7,
                        onCompressSuccess: (compressedFile, convertedExtension) => {
                            fileExtension = convertedExtension;
                            resolve(compressedFile);
                        },
                        onCompressError: () => resolve(undefined),
                        isCheckingSizeElsewhere: true,
                    });
                });
                if (compressedFile) {
                    if (compressedFile.size < filtered.size)
                        filtered = compressedFile;
                }
                else
                    filtered = undefined; // ! 압축 실패 => 유효하지 않은 이미지로 간주
            }
            if (filtered) {
                if (filtered.size > 3000000) {
                    errorToastMessage.current = t('최대 3MB 업로드 할 수 있어요');
                }
                else
                    return { file: filtered, extension: fileExtension };
            }
        }
    });
    const prepareFileObjArr = (fileArr) => __awaiter(this, void 0, void 0, function* () {
        let prepared = [];
        for (const file of fileArr) {
            const filteredFileObj = yield getFilteredFileObj(file);
            if (filteredFileObj)
                prepared.push(filteredFileObj);
        }
        return prepared;
    });
    const assignPreparedFileObj = (preparedFileObj) => __awaiter(this, void 0, void 0, function* () {
        return yield (0, api_1.putData)(`/api/v1/members/${userId}/settlement-request/upload`, {
            file_extension: preparedFileObj.extension,
            filename: preparedFileObj.file.name,
        }).then(res => res.data.result);
    });
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const getPresignedFileObjArr = (preparedFileObjArr) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        let presigned = [];
        for (const preparedFileObj of preparedFileObjArr) {
            try {
                const presignedInfoObj = yield assignPreparedFileObj(preparedFileObj);
                presigned.push(Object.assign(Object.assign({}, preparedFileObj), presignedInfoObj));
            }
            catch (error) {
                if (error instanceof axios_1.AxiosError) {
                    const errorStatus = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
                    const errorCode = (_d = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
                    if (errorStatus === 403)
                        (0, errors_1.handle403Error)(error);
                    else
                        (0, errors_1.commonErrorConfirm)({ confirm, errorCode: errorCode || errorStatus });
                }
                return false;
            }
        }
        return presigned;
    });
    const uploadPresignedFile = (presignedFileObj) => __awaiter(this, void 0, void 0, function* () {
        const { presigned_url, content_type, file, media_id } = presignedFileObj;
        const mediaId = Number(media_id);
        return yield axios_1.default
            .put(presigned_url, file, { headers: { 'Content-Type': content_type } })
            .then(() => ({
            media_id: mediaId,
            fileUrl: URL.createObjectURL(file),
            fileName: file.name,
        }));
    });
    const getUploadedInfoObjArr = (presignedFileObjArr) => __awaiter(this, void 0, void 0, function* () {
        var _e;
        let uploaded = [];
        for (const presignedFileObj of presignedFileObjArr) {
            try {
                const uploadedInfoObj = yield uploadPresignedFile(presignedFileObj);
                uploaded.push(uploadedInfoObj);
            }
            catch (error) {
                if (error instanceof axios_1.AxiosError) {
                    const errorStatus = (_e = error.response) === null || _e === void 0 ? void 0 : _e.status;
                    (0, errors_1.commonErrorConfirm)({
                        confirm,
                        errorCode: errorStatus,
                        errorReason: '(failed uploading images to AWS)',
                    });
                }
                return false;
            }
        }
        return uploaded;
    });
    const completeUploadFile = (uploadedInfoObj) => __awaiter(this, void 0, void 0, function* () {
        const { media_id } = uploadedInfoObj;
        return yield (0, api_1.patchData)(`/api/v1/members/${userId}/settlement-request/upload-complete`, {
            media_id,
        }).then(() => uploadedInfoObj);
    });
    const getCompletedInfoObjArr = (uploadedInfoObjArr) => __awaiter(this, void 0, void 0, function* () {
        var _f, _g, _h, _j;
        const completed = [];
        for (const uploadedInfoObj of uploadedInfoObjArr) {
            try {
                const completedInfoObj = yield completeUploadFile(uploadedInfoObj);
                completed.push(completedInfoObj);
            }
            catch (error) {
                if (error instanceof axios_1.AxiosError) {
                    const errorStatus = (_f = error.response) === null || _f === void 0 ? void 0 : _f.status;
                    const errorCode = (_j = (_h = (_g = error.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.meta) === null || _j === void 0 ? void 0 : _j.alert_type;
                    if (errorStatus === 403)
                        (0, errors_1.handle403Error)(error);
                    else
                        (0, errors_1.commonErrorConfirm)({ confirm, errorCode: errorCode || errorStatus });
                }
                return false;
            }
        }
        return completed;
    });
    const { setValue, watch, register, formState: { errors }, clearErrors, } = formReturn;
    const proofFiles = Array.from(watch('proof_files') || []);
    const proofFileCount = proofFiles.length;
    const maxFileCount = isPaymentRequest ? 3 : 1;
    const availableFileCount = maxFileCount - proofFileCount;
    const uploadProofFiles = (fileList) => __awaiter(this, void 0, void 0, function* () {
        setIsUploadingFile(true);
        const fileArr = Array.from(fileList).slice(0, availableFileCount);
        const preparedFileObjArr = yield prepareFileObjArr(fileArr);
        if (!preparedFileObjArr.length) {
            errorToastMessage.current && (0, functions_1.showToastMessage)({ message: errorToastMessage.current });
            errorToastMessage.current = '';
            setIsUploadingFile(false);
        }
        else {
            const presignedFileObjArr = yield getPresignedFileObjArr(preparedFileObjArr);
            if (!presignedFileObjArr)
                setIsUploadingFile(false);
            else {
                const uploadedInfoObjArr = yield getUploadedInfoObjArr(presignedFileObjArr);
                if (!uploadedInfoObjArr)
                    setIsUploadingFile(false);
                else {
                    const completedInfoObjArr = yield getCompletedInfoObjArr(uploadedInfoObjArr);
                    if (completedInfoObjArr) {
                        setValue('proof_files', proofFiles.concat(completedInfoObjArr));
                    }
                    setIsUploadingFile(false);
                    (0, functions_1.showToastMessage)({ message: errorToastMessage.current || t('업로드 완료') });
                    errorToastMessage.current = '';
                    clearErrors('proof_files');
                }
            }
        }
    });
    const uploadInputId = `settlement_request_file_uploader_${isPaymentRequest ? 'payment' : isCompanyRegister ? 'company_register' : 'withdraw'}`;
    const requiredMessage = t(isPaymentRequest ? '제작비 증빙이 필요해요' : '사업자 등록증을 등록해주세요');
    const hasProofFilesError = Boolean(errors.proof_files);
    return ((0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ component: "label", sx: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            rowGap: '2px',
            width: '56px',
            height: '56px',
            p: '7px',
            border: `1px solid ${hasProofFilesError ? 'var(--error-main)' : 'var(--gray-10)'}`,
            borderRadius: '8px',
            backgroundColor: 'var(--surface-bg) !important',
            color: 'var(--gray-40)',
            lineHeight: '20px',
            fontSize: '14px',
        } }, { children: [isUploadingFile ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 16, color: "secondary", thickness: 6 })) : ((0, jsx_runtime_1.jsx)(svgs_1.PlusWhiteCircleBlackSvg, { css: { width: '16px', height: '16px' } })), `(${proofFileCount}/${maxFileCount})`, (0, jsx_runtime_1.jsx)("input", Object.assign({ id: uploadInputId, type: "file", hidden: true }, register('proof_files', {
                validate: () => isPaymentRequest || isCompanyRegister
                    ? Boolean(proofFileCount) || requiredMessage
                    : true,
            }), { disabled: isUploadingFile || proofFileCount >= maxFileCount, multiple: isPaymentRequest, onChange: e => {
                    if (e.target.files)
                        uploadProofFiles(e.target.files);
                }, onClick: e => {
                    (0, webview_app_1.askPhotoPermissionsToWVA)(uploadInputId, e);
                    e.currentTarget.value = '';
                } }))] })));
}
exports.default = default_1;
